// extracted by mini-css-extract-plugin
export default {"widthLogo":"Nav_widthLogo__sy8VL","btnOrange":"Nav_btnOrange__v1azG","btnOutlinOrange":"Nav_btnOutlinOrange__Cjc+o","menu":"Nav_menu__XZOMe"};